<template>
    <transition name="fade">
        <div v-if="visible">
            <div class="overlay" ></div>
              <div class="popup" >
                <button class="close-button" @click="closePopup">X</button>
                <div style="font-size:18px; padding-top:10px">{{ trans[localLanguage]['richiesta_preventivo'] }}</div>
                <form @submit.prevent="submitForm" style="padding-top:30px">
                
                  <label for="tipologia">{{ trans[localLanguage]['tipologia'] }}</label>
                  <select name="tipologia" required  v-model="form.tipologia">
                    <option value="privato">{{ trans[localLanguage]['privato'] }}</option>
                    <option value="azienda">{{ trans[getLanguage()]['azienda'] }}</option>
                  </select>

                  <label for="nome">{{ trans[localLanguage]['ragione_sociale'] }}</label>
                  <input id="nome" required v-model="form.nome" type="text" />
          
                  <!-- <label for="cognome">Cognome:*</label>
                  <input id="cognome" required v-model="form.cognome" type="text" /> -->
          
                  <label for="telefono">{{ trans[localLanguage]['telefono'] }}</label>
                  <input id="telefono" v-model="form.telefono" type="number" />

                  <label for="provincia">{{ trans[localLanguage]['provincia'] }}</label>
                  <input id="provincia" required v-model="form.provincia" type="text" />
          
                  <label for="email">{{ trans[localLanguage]['email'] }}</label>
                  <input id="email" required v-model="form.email" type="email" />
          
                  <label for="note">{{ trans[localLanguage]['richiesta'] }}</label>
                  <textarea id="note" v-model="form.note"></textarea>
                  <div style="display:flex; justify-content:flex-start; align-items:center">

                      <input type="checkbox" id="privacy" v-model="privacyAccepted" required  />
                        <label for="privacy" style="padding-left:10px">
                          {{ trans[localLanguage]['privacy'] }}
                        <a href="/path/to/your/privacy/policy" target="_blank">privacy policy</a>
                        </label>
                  </div>
                  <div>{{ trans[localLanguage]['campi_obbligatori'] }}</div>

          
                  <button type="submit" style="margin-top:40px;margin-bottom:20px;">{{ trans[localLanguage]['invia'] }}</button>
                </form>
              </div>
        </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      visible: Boolean
    },
    data() {
      return {
        localLanguage: 'en',
        form: {
          tipologia: '',
          nome: '',
          // cognome: '',
          telefono: '',
          provincia: '',
          email: '',
          note: '',
        },
        privacyAccepted: false,
        trans: {
        'it': {
          richiesta_preventivo: 'Invia richiesta preventivo',
          tipologia: "Tipologia*",
          ragione_sociale: "Nome/Ragione Sociale*",
          telefono: "Telefono",
          provincia: "Provincia*",
          email: "Email*",
          richiesta: "Richiesta/Note*",
          privacy: "Accetto la",
          campi_obbligatori: '*Campi obbligatori',
          invia:'Invia',
          privato: 'Privato',
          azienda: 'Azienda',
        },
        'en': {
          richiesta_preventivo: 'Send quote request',
          tipologia: "You're a*",
          ragione_sociale: "Name/Company name *",
          telefono: "Tel",
          provincia: "Country*",
          email: "Email*",
          richiesta: "Message/Note*",
          privacy: "I understand and agree to the",
          campi_obbligatori: '*Required fields',
          invia:'Send',
          privato: 'Private',
          azienda: 'Company',
        }
      }
      };
    },
    methods: {
      getLanguage() {
        if(localStorage.getItem('selectedLanguage')){
        this.localLanguage =  localStorage.getItem('selectedLanguage')
        return localStorage.getItem('selectedLanguage');
        }
    },
      submitForm() {
        // this.$emit('sendMail', this.form);
        this.$emit('sendMail', {
            tipologia: this.form.tipologia,
            nome: this.form.nome,
            // tipologia: this.form.tipologia,
            // cognome: this.form.cognome,
            telefono: this.form.telefono,
            provincia: this.form.provincia,
            email: this.form.email,
            note: this.form.note,
            privacyAccepted: this.privacyAccepted,
        });
        this.form.nome = '';
        this.tipologia = '';
        // this.form.cognome = '';
        this.form.telefono = '';
        this.form.provincia = '';
        this.form.email = '';
        this.form.note = '';
        this.privacyAccepted = false;
        // Implementa la logica per inviare il modulo
        console.log(this.form);
      },
      closePopup() {
        this.$emit('close');
        }
    }
  }
  </script>
  <style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  
  .popup {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
    max-width: 500px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    z-index: 1000;
  }
  .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
  
  form {
    display: flex;
    flex-direction: column;
  }
  
  label {
    margin-top: 10px;
  }
  
  input, textarea, select {
    margin-top: 5px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  button {
    margin-top: 10px;
    padding: 10px;
    background: #21BA45;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  .close-button {
  position: absolute;
  top: 10px;
  right: 20px;
  border: none;
  background: red;
  font-size: 18px;
  cursor: pointer;
  padding:5px 10px
}
  </style>

  
  
  
  